import RepositoryFactory from '@/repository/RepositoryFactory';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * データを取得
 */
export async function fetchSettings() {
  const fetchedSimpleSettings = await shiftServiceRepositories.settings.index();
  return fetchedSimpleSettings.data;
}

export default {
  fetchSettings,
};
